import { Input, RadioButton } from '@gje/forms';
import React from 'react';
import HelpBox from '../layout/components/HelpBox/HelpBox';
import classNames from 'classnames';
import { isIOS, isSafari } from 'react-device-detect';
import { ErrorMessage } from '@gje/forms/lib/error-message';
import uuid from 'uuid';
import { Label } from '@gje/forms/lib/label-component';
import { isVillaagarna } from '../services/partners/partnersService';
import useMobileOrTablet from '../hooks/useMobileOrTablet';

export const renderInput = ({ input, data, meta }) => (
    <Input
        className={input.className}
        onChange={input.onChange}
        labelText={data.label}
        id={data.label}
        name={input.name}
        onBlur={input.onBlur}
        errorText={meta.error}
        value={input.value.toUpperCase()}
        invalid={(meta.touched && meta.error) || data.backendError}
        placeholder={data.placeHolder}
        type={data.type}
        errorClassName={isVillaagarna() && 'villaagarna-orange-bg-color'}
    />
);

export const renderInputWithHelpBox = ({ input, data, meta }) => {
    return (
        <div className="col-sm-9">
            <div className="form-group input-medium">
                <Input
                    onChange={input.onChange}
                    labelText={data.label}
                    id={input.name}
                    type={data.type}
                    name={input.name}
                    onBlur={input.onBlur}
                    errorText={meta.error}
                    value={input.value.toUpperCase()}
                    invalid={(meta.touched && meta.error) || data.backendError}
                    placeholder={data.placeHolder}
                    noHelpTextButton={true}
                    errorClassName={'max-width-364'}
                    inputClassName={
                        isIOS || isSafari ? 'apple-input-line-height' : ''
                    }
                />
                <HelpBox helpText={data.helpText} id={input.name + 'helpBox'} />
            </div>
        </div>
    );
};

export const renderDropdown = ({ input, data }) => {
    return (
        <div
            className={classNames(
                `col-sm-${data.columnSize ? data.columnSize : `9`}`,
                'display-inline-flex align-items'
            )}>
            <div
                className={classNames(
                    'form-group',
                    'input-medium',
                    data.wrapperClassName
                )}>
                <label htmlFor={input.name} className="text-left input-label">
                    {data.label}
                </label>
                <div className="flex align align-items">
                    <select
                        children={renderOptions(data.options)}
                        id={input.name}
                        name={input.name}
                        onChange={e => data.onChange(e, input.onChange)}
                        className={classNames(
                            'form-control',
                            'min-height-53',
                            'dropdown-border',
                            data.selectClassName
                        )}
                        defaultValue={data.defaultValue}
                    />
                    <HelpBox
                        helpText={data.helpText}
                        id={input.name + 'helpBox'}
                        iconClassName={data.helpBoxCustomClassName}
                        place={useMobileOrTablet() ? 'left' : null}
                    />
                </div>
            </div>
        </div>
    );
};

const renderOptions = options => {
    return options.map((option, index) => {
        return (
            <option key={index} value={option.value} children={option.item} />
        );
    });
};

export const renderRadioButtons = ({
    input,
    meta: { touched, error },
    ...custom
}) => {
    const { options, labelText, ...propsWithoutCustom } = custom;
    return (
        <div className={'margin-bottom-26 padding-left-6-5'}>
            <Label labelText={labelText} id="s" />
            <div>
                {options.map(o => (
                    <div className={'display-block-xs'} key={o.labelText}>
                        <RadioButton
                            {...input}
                            {...propsWithoutCustom}
                            id={uuid.v4()}
                            key={o.value}
                            label={o.labelText}
                            value={o.value}
                            className={'padding-right-13 margin-top-13'}
                            name={input.name}
                            checked={
                                o.value === input.value || o.checked
                                    ? 'true'
                                    : ''
                            }
                        />
                    </div>
                ))}
            </div>
            <ErrorMessage
                errorText={error}
                invalid={touched && error}
                className={classNames({
                    'villaagarna-orange-bg-color': isVillaagarna()
                })}
            />
        </div>
    );
};
